export default {
  data () {
    return {
      currentPage: 0,
      pristine: true,
      filterError: undefined
    }
  },
  watch: {
    filter: {
      handler (newFilter) {
        if (this.currentPage !== 0) {
          this.currentPage = 0
        } else {
          this.doFilter()
        }
      },
      deep: true
    },
    currentPage () {
      this.doFilter()
    }
  },
  created () {
    this.doFilter()
  },
  methods: {
    doFilter () {
      if (this.filter) {
        const applied = this.applyFilter && this.applyFilter(Object.assign({ page: this.currentPage }, this.filter), this.pristine)
        this.pristine = false

        if (applied && applied.finally) {
          applied.then(this.clearError)
          applied.catch(this.setError)
        }
        return applied
      }
    },
    clearError () {
      this.filterError = undefined
    },
    setError (error) {
      this.filterError = error
    }
  }
}
